export default __webpack_public_path__ + "static/media/Hund-auf-Zahlblöcken.c0d1da2b.webp";